import { useRestPostQuery } from 'utils/hooks/api';
import { CAMPAIGNS_METRICS_MEDIUMS } from 'modules/missionControl/constants';
import {
  CAMPAIGNS_TABLE_METRICS,
  CAMPAIGNS_TIMESERIES_METRICS,
} from '../components/HealthDashboard/CampaignsHealthMetrics/CampaignsHealthMetrics.constants';
import { useCallback, useMemo } from 'react';
import { HealthMetricsRequest, HealthMetricsResponse } from '../types/health';

export type UseQueryCampaignsHealthMetricsState = ReturnType<typeof useQueryCampaignsHealthMetrics>;

export type UseQueryCampaignsHealthMetricsArgs = {
  labels: number[];
  messageTypes: number[];
  startTime: string;
  endTime: string;
};

const MISSION_CONTROL_HEALTH_METRICS_URL = '/i/health/metrics';

const HIGH_LEVEL_METRICS = [...CAMPAIGNS_TIMESERIES_METRICS, ...CAMPAIGNS_TABLE_METRICS].map(
  (metric) => ({ enumName: metric }),
);

export const useQueryCampaignsHealthMetrics = ({
  labels,
  messageTypes,
  startTime,
  endTime,
}: UseQueryCampaignsHealthMetricsArgs) => {
  const requestPayload = useMemo(
    () => ({
      filterInfo: {
        labels,
        messageTypes,
        mediums: CAMPAIGNS_METRICS_MEDIUMS,
      },
      highLevelMetrics: HIGH_LEVEL_METRICS,
      startTime,
      endTime,
    }),
    [labels, messageTypes, startTime, endTime],
  );

  const {
    data: metrics,
    isLoading,
    isError: hasError,
    refetch: refetchHealthMetrics,
  } = useRestPostQuery<HealthMetricsResponse, HealthMetricsRequest>(
    MISSION_CONTROL_HEALTH_METRICS_URL,
    requestPayload,
  );

  const retryHealthMetrics = useCallback(async () => {
    await refetchHealthMetrics();
  }, [refetchHealthMetrics]);

  return {
    metrics,
    isLoading,
    hasError,
    refetch: retryHealthMetrics,
  };
};
